import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import { useRetrievePlayerByExternalUserId, useRetrieveTeamsByPlayerId, useRetrieveUserPlayerPermissions, useUpdateExternalUser, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { useNumericParams } from "../utils/useNumericParams";
import { OfflinePlayerForm } from "./OfflinePlayerForm";
const playerToMetadata = (player) => ({
    nationality: player.nationality ?? "US",
    foot: player.foot || "Right",
    positionOne: player.positionOne ?? "GK",
    positionTwo: player.positionTwo,
    bio: player.bio,
    heading: player.heading,
    passing: player.passing,
    positioning: player.positioning,
    defending: player.defending,
    finishing: player.finishing,
    dribbling: player.dribbling,
    shooting: player.shooting,
    tackling: player.tackling,
    crossing: player.crossing,
    leadership: player.leadership,
    communication: player.communication,
    speed: player.speed,
    fitness: player.fitness,
    keeping: player.keeping,
});
export const UpdateExternalUser = () => {
    const { id } = useNumericParams();
    const navigate = useNavigate();
    const { data: player, isLoading, error, } = useRetrievePlayerByExternalUserId({ externalUserId: id });
    // Permission is on the resolved player, not the route's external-user id.
    const { data: playerPermissions, isLoading: permissionsLoading, error: permissionsError, } = useRetrieveUserPlayerPermissions({ playerId: player?.id });
    const { canModify = false } = playerPermissions || {};
    const { data: teams, isLoading: isTeamsLoading, error: teamsError, } = useRetrieveTeamsByPlayerId({ playerId: player?.id, enabled: canModify });
    const updateExternalUserMutation = useUpdateExternalUser({
        player,
        playerTeams: teams,
        onMutate: () => { },
        onSuccess: () => {
            navigate(`/players/${player.id}/`);
        },
        onError: () => { },
    });
    // Resolve the player first (its id drives the permission check), then gate.
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error || !player || !player.externalUser) {
        return _jsx(ErrorView, { error: error });
    }
    if (permissionsLoading) {
        return _jsx(Loading, {});
    }
    if (permissionsError) {
        return _jsx(ErrorView, { error: permissionsError });
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (updateExternalUserMutation.isLoading || isTeamsLoading) {
        return _jsx(Loading, {});
    }
    if (teamsError || !teams) {
        return _jsx(ErrorView, { error: teamsError });
    }
    return (_jsx(OfflinePlayerForm, { title: "Edit Player", submitLabel: "Save", defaultValues: {
            externalUser: {
                firstName: player.externalUser.firstName,
                lastName: player.externalUser.lastName,
            },
            player: playerToMetadata(player),
        }, isError: !!updateExternalUserMutation.isError, errorMessage: "Failed to update player!", onSubmit: (data) => updateExternalUserMutation.mutate(data), onCancel: () => navigate(-1) }));
};
